import React, { useState } from "react";
import { Grid, Box, Stack, Button } from "@mui/material";
import { CustomFormLabel, CustomTextField } from "../formsComponents";
import {
  ILocationResponsePayload,
  LocationAutoComplete,
} from "../LocationAutoComplete/LocationAutoComplete";
import { Dialog } from "../Dialogs/Dialog";
interface AddressFieldWithDialogProps {
  address: string | null;
  onAddressChange: (data: ILocationResponsePayload) => void;
  disable?: boolean;
  label?: string;
  // Overrides the "Search Address" dialog's z-index. Needed when this field
  // is rendered inside another modal/drawer with a custom z-index (e.g. a
  // RightPanel), so the dialog renders above it instead of behind it.
  dialogZIndex?: number;
}

export const AddressSearchAutoComplete: React.FC<
  AddressFieldWithDialogProps
> = ({ address, onAddressChange, disable, label = "Address", dialogZIndex }) => {
  const [addressDialogOpen, setAddressDialogOpen] = useState(false);

  // Open and close dialog handlers
  const handleOpenDialog = () => setAddressDialogOpen(true);
  const handleCloseDialog = () => setAddressDialogOpen(false);

  // Handle address selection from LocationAutoComplete component
  const handleAddressSelect = (data: ILocationResponsePayload) => {
    onAddressChange(data);
    setAddressDialogOpen(false);
  };

  return (
    <Grid container>
      <Grid item xs={12} md={12}>
        <Box>
          {/* Address label and button */}
          <Stack direction="row" justifyContent="space-between">
            <CustomFormLabel>{label}</CustomFormLabel>
            <Button variant="text" onClick={handleOpenDialog} disabled={disable}>
              Search Address
            </Button>
          </Stack>

          {/* Address input field */}
          <CustomTextField
            name="address"
            variant="outlined"
            size="small"
            fullWidth
            disabled={disable}
            value={address || ""} // Ensure it's always a string
            onChange={(e) =>
              onAddressChange({
                address: e.target.value,
                city: "",
                country: "",
                state: "",
                postalCode: "",
              })
            } // Handle user typing
          />

          {/* Dialog for address search */}
        </Box>
      </Grid>
      <Dialog
        open={addressDialogOpen}
        title="Search Address"
        onClose={handleCloseDialog}
        size="xs"
        fullWidth
        zIndex={dialogZIndex}
        actions={[
          {
            type: "button",
            label: "Close",
            variant: "text",
            onClick: handleCloseDialog,
          },
        ]}
      >
        <Grid item xs={12} md={12} marginBottom={30}>
          <CustomFormLabel>Enter Address</CustomFormLabel>
          <LocationAutoComplete
            id="address-autocomplete"
            variant="outlined"
            size="small"
            fullWidth
            value={address}
            onLocationChange={handleAddressSelect}
          />
        </Grid>
      </Dialog>
    </Grid>
  );
};
